export default "__VITE_PUBLIC_ASSET__32867951__"